export default function Privacy() {
  return (
    <section
      id="privacidad"
      data-testid="privacy"
      className="py-32 md:py-48 relative"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
              ◊ Privacidad por diseño
            </p>
            <p className="mt-4 text-sm text-ink/70 max-w-xs">
              No es una sección de configuración. Es la arquitectura completa.
            </p>
          </div>

          <div className="col-span-12 md:col-span-9">
            <blockquote className="font-serif text-[10vw] md:text-[7vw] lg:text-[6.5rem] xl:text-[8rem] leading-[0.95] tracking-tighter">
              <span className="text-ink/30">«</span>Tus datos te <span className="italic text-coral">pertenecen</span>.
              Tu silencio<br />también<span className="text-ink/30">.»</span>
            </blockquote>
          </div>
        </div>

        {/* Privacy guarantees */}
        <div className="mt-20 md:mt-32 grid grid-cols-1 md:grid-cols-3 gap-px bg-ink/10 rounded-2xl overflow-hidden border hairline">
          {[
            {
              n: "01",
              t: "Cero venta de datos",
              d: "Nunca venderemos tu información a terceros. Auditoría pública anual.",
            },
            {
              n: "02",
              t: "Cifrado por defecto",
              d: "Mensajes y archivos cifrados extremo a extremo desde el primer día.",
            },
            {
              n: "03",
              t: "Control granular",
              d: "Decide quién ve qué, cuándo, durante cuánto tiempo. Borrado real al instante.",
            },
            {
              n: "04",
              t: "Sin tracking cruzado",
              d: "Ovamx no te sigue en otras webs ni apps. No tenemos píxeles de seguimiento.",
            },
            {
              n: "05",
              t: "Algoritmos auditables",
              d: "Código abierto en los componentes críticos del feed. Verificable por terceros.",
            },
            {
              n: "06",
              t: "Identidad opcional",
              d: "Verificación voluntaria. Pseudonimato pleno cuando lo necesites.",
            },
          ].map((g) => (
            <div
              key={g.n}
              className="bg-cream p-8 md:p-10 hover:bg-cream-deep/40 transition-colors duration-500"
            >
              <div className="flex items-baseline justify-between mb-6">
                <span className="font-mono text-xs text-coral">{g.n}</span>
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid">
                  garantía
                </span>
              </div>
              <h4 className="font-serif text-2xl md:text-3xl leading-tight mb-3">
                {g.t}
              </h4>
              <p className="text-sm text-ink/70 leading-relaxed">{g.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
